import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import { Api } from '../enum/Api';

@Injectable()
export class LocationService {
  constructor(private httpService: HttpService) { }

  public getAddressByZipcode(zipcode: string, includeCoordinates: boolean): Observable<any> {
    return this.httpService.post('crm/address/findAddressByZipCode', Api.One_Portal,
      {
        'zipcode': zipcode,
        'includeCoordinates': includeCoordinates
      });
  }

}
